import InviteComponent from '@components/invite';
import * as React from 'react';

export interface IInvitePageProps {}

export default function InvitePage(props: IInvitePageProps) {
  return <InviteComponent />;
}
